import styled from "styled-components";

const justifyContent = { 
  'space-between': "space-between",
  start: "start",
  end: "end",
  center: "center"
}

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndex.contentFixed + 4};
  background-color: ${({ theme }) => theme.color.white};
`;

export const MarginContent = styled.div`
  margin-left: 15px;
  margin-right: 15px;
`;

export const Header = styled.div`
  padding-top: 16px;
  padding-bottom: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.light};
`;

export const HeaderContent = styled(MarginContent)``;

export const ButtonClose = styled.button`
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background-color: transparent;
`;

export const WrapLogo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${props => justifyContent[props.flexPosition]};//space-between;
  width: 100%;
`;

export const IconDescription = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 14px;
`;

export const IconWrapper = styled.button`
  height: 44px;
  width: 44px;
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.iconBg};//#e7edfa;
  border-radius: 0.1875rem;
  border: 0;

  &.go-back {
    background-color: rgba(100, 100, 100, 0.1);
    svg {
  
      height: 16px;
      path {
        fill: rgba(100, 100, 100, 0.8);
      }
    }
  }

  svg {
    height: 20px;
    width: auto !important;

    path {
      fill: ${props => props.iconColor};
    }
  }
`;

export const WrapInfo = styled.div`
  margin-left: 10px;
`;

export const TermsTitle = styled.div`
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeight.fw700};
  color: ${({ theme }) => theme.color.black};
`;

export const TermsDate = styled.div`
  font-size: 0.75rem;
  font-weight: ${({ theme }) => theme.fontWeight.fw400};
  color: ${({ theme }) => theme.color.gray};
`;

export const Content = styled(MarginContent)`
  background-color: ${({ theme }) => theme.color.white};
  height: calc(100% - 190px);
  overflow: hidden;
  overflow-y: auto;
  padding-top: 1.25rem;
  padding-bottom: 3.125rem;
  
  &.readonly {
    height: calc(100% - 5rem);
  }
`;

export const ContentBlock = styled.div`
  padding-bottom: 6.25rem;
`;

export const Title = styled.div`
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeight.fw700};
  color: ${({ theme }) => theme.color.black};
`;

export const Text = styled.div`
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.fontWeight.fw400};
  color: ${({ theme }) => theme.color.gray};
  margin-top: 5px;
`;

export const BottomPageActions = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: ${({ theme }) => theme.zIndex.contentFixed + 5};
  padding-bottom: 15px;
  padding-top: 15px;
  opacity: 1;
  background: rgb(255, 255, 255);
  background: -moz-linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.742734593837535) 54%,
    rgba(255, 255, 255, 0) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.742734593837535) 54%,
    rgba(255, 255, 255, 0) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.742734593837535) 54%,
    rgba(255, 255, 255, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#ffffff",GradientType=1);

  &::before {
    content: "";
    display: block;
    height: 60px;
    width: 100%;
    background-color: ${({ theme }) => theme.color.blue};
    background: rgb(255, 255, 255);
    background: -moz-linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.742734593837535) 54%,
      rgba(255, 255, 255, 0) 100%
    );
    background: -webkit-linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.742734593837535) 54%,
      rgba(255, 255, 255, 0) 100%
    );
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.742734593837535) 54%,
      rgba(255, 255, 255, 0) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#ffffff",GradientType=1);
  }
`;

export const WrapButtons = styled(MarginContent)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    &:last-child {
      margin-left: 15px;
    }
  }
`;
